import { ChangeEvent, FormEvent } from "react";
import { useDispatch, useSelector } from "react-redux";
import { toast } from "react-toastify";

import AddJobAllJobsProfile from "../../StylesWrappers/General/AddJobAllJobsProfile";
import TitleText from "../../components/General/Helmet";
import { AppDispatch, RootState } from "../../store";
import {
  clearInput,
  collectInput,
  postJobAction,
} from "../../features/postJob/postJobSlice";
import { PostJobComp } from "../../components/postJobs";
import { toastMessage } from "../../utils/toastMessage";

const PostJob = () => {
  const { inputs } = useSelector((store: RootState) => store.postJobStore);

  const dispatch = useDispatch<AppDispatch>();

  const { position, company, jobType, jobLocation } = inputs;

  const handleChange = (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    dispatch(collectInput({ name, value }));
  };

  const handleSelect = (e: ChangeEvent<HTMLSelectElement>) => {
    const { name, value } = e.target;
    dispatch(collectInput({ name, value }));
  };

  // MAKE SURE THE LINK TO APPLY FOR JOB STARTS WITH https://
  const checkForHttps = (url: string) => {
    if (url?.startsWith("https://")) {
      return url;
    }
    return "https://" + url;
  };

  // SUBMIT THE POST JOB FORM
  const handleSubmit = (e: FormEvent) => {
    e.preventDefault();

    if (!position || !company || !jobLocation) {
      toastMessage(
        `Position, company, job location and job description should not be empty`,
        dispatch,
        toast.error
      );
      return;
    }
    if (!jobType) {
      toastMessage("Please select the job type", dispatch, toast.error);
      return;
    }

    // Add https where needed
    const newInputs = {
      ...inputs,
      jobUrl: checkForHttps(inputs.jobUrl),
      socialMedia: {
        whatsapp: checkForHttps(inputs.socialMedia.whatsapp),
        telegram: checkForHttps(inputs.socialMedia.telegram),
      },
    };
    // console.log(newInputs);

    dispatch(postJobAction(newInputs));
  };

  const handleReset = () => {
    dispatch(clearInput());
  };

  return (
    <AddJobAllJobsProfile>
      <TitleText title="Jobtrackier - Post Job" />
      <p className="page__title">Post a Job</p>
      <p className="page__intro">Post a job for others to apply here</p>
      <PostJobComp
        handleChange={handleChange}
        handleSelect={handleSelect}
        handleReset={handleReset}
        handleSubmit={handleSubmit}
      />
    </AddJobAllJobsProfile>
  );
};

export default PostJob;
